export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-ivory">
    <div className="h-px w-full brand-gradient" aria-hidden />
    <div className="mx-auto flex max-w-7xl flex-col gap-10 px-6 py-16 md:flex-row md:items-end md:justify-between md:px-12">
      <div>
        <img src="/logo.svg" alt="S & H | Automotive Acquisition Group" className="h-14 w-auto" />
        <p className="mt-6 max-w-xs text-sm leading-relaxed text-stone">
          Private vehicle acquisition. Toronto-based, serving clients across Canada.
        </p>
      </div>
      <div className="flex flex-col gap-3 text-sm md:items-end">
        <a href="#contact" data-testid="footer-contact-link" className="link-line pb-1 text-ink">Begin a request</a>
        <p className="text-mist">© {new Date().getFullYear()} S &amp; H | Automotive Acquisition Group</p>
      </div>
    </div>
  </footer>
);
